import React from "react";
import style from "../styles/BrandPromise.module.css";
function BrandPromise() {
  return (
    <div>
      <p className={style.desc}>THE INFINITE DIGITALS BRAND PROMISE</p>
      <div className={style.cont_promise}>
        <div>
          <img
            src="https://www.reliancedigital.in/medias/Insta-Delivery-Brand-Promise-Icon.png?context=bWFzdGVyfGltYWdlc3wxNTM3fGltYWdlL3BuZ3xpbWFnZXMvaGI2L2gwNS85NDQ3MTcwMzQyOTQyLnBuZ3w2Yzc1ZmY1ZjYwOWIyNWU0ZTgwMjFlYmRkMTU5ZTgzMGI4ZDNmZTE2NjVjYmRlMmUwMmRiODI2OTExNWM5ZTdk"
            alt=""
          />
          <h5 className={style.heading_prom}>INSTA DELIVERY</h5>
          <p className={style.para_prom}>LESS THAN 3HRS.</p>
        </div>
        <div>
          <img
            src="https://www.reliancedigital.in/medias/Best-Finance-Options-2.png?context=bWFzdGVyfGltYWdlc3wxMjM4fGltYWdlL3BuZ3xpbWFnZXMvaDJmL2gxOS85NDQ3MTcwNDA4NDc4LnBuZ3xlMDBiNjY4YWI5YzMzYjZkZDhlZTMyMDhjYjE2YzI2OTY2NWJhYjk2M2VkNzdjZDg3NTNlMGEyMTA1ZjFlODZh"
            alt=""
          />
          <h5 className={style.heading_prom}>BEST FINANCE OPTIONS</h5>
          <p className={style.para_prom}>WIDE RANGE</p>
        </div>
        <div>
          <img
            src="https://www.reliancedigital.in/medias/service-img.png?context=bWFzdGVyfGltYWdlc3w5MTB8aW1hZ2UvcG5nfGltYWdlcy9oMDYvaGEzLzkwOTA3OTc5OTQwMTQucG5nfGJjZmJhNzM1ODdkYTQ5ODI3YzNiMzQ1ZTdlM2JjNjUwMTBjM2E3YWFjNmUxZjdmMmEyOGRjZDMxOGI4ZWE0MWY"
            alt=""
          />
          <h5 className={style.heading_prom}>SERVICE GUARANTEE</h5>
          <p className={style.para_prom}>HASSLE FREE</p>
        </div>
        <div>
          <img
            src="https://www.reliancedigital.in/medias/unmatched-network-img.png?context=bWFzdGVyfGltYWdlc3w3NDV8aW1hZ2UvcG5nfGltYWdlcy9oODIvaDJhLzkwOTA3OTgwNTk1NTAucG5nfDFmMThjYzdiYTNiOTgxYjA5YzdlZTFiMmQyODI5MGY2NTM4ZTcxOWZkZTA1ZjAzY2Q1ZTk5YjQ1NTMxMWViYzU"
            alt=""
          />
          <h5 className={style.heading_prom}>UNMATCHED NETWORK</h5>
          <p className={style.para_prom}>700 CITIES,2000 STORES</p>
        </div>
      </div>
    </div>
  );
}

export default BrandPromise;
